import * as THREE from "three";
import React, { useRef } from "react";
import { Torus, Sphere, useTexture } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import useStore from "../AppStore";
import path from "../path";

const PlanetTwo = React.forwardRef((props, ref) => {
  const astroRef = useRef(null);

  useFrame(({ clock }) => {
    const top = useStore.getState().top;
    astroRef.current.rotation.y = -clock.elapsedTime * 0.1 - top * 0.01;
  });

  const colorMap = useTexture(path + "/assets/planets/Planeta2Col.png");
  const normalMap = useTexture(path + "/assets/planets/Planeta2Normal.png");
  const roughMap = useTexture(path + "/assets/planets/Planeta2Roughness.png");

  return (
    <group ref={ref} {...props} dispose={null}>
      <Sphere args={[1, 32, 32]} ref={astroRef}>
        <meshStandardMaterial
          map={colorMap}
          normalMap={normalMap}
          roughnessMap={roughMap}
        />
      </Sphere>
    </group>
  );
});

useTexture.preload(path + "/assets/planets/Planeta2Col.png");
useTexture.preload(path + "/assets/planets/Planeta2Normal.png");
useTexture.preload(path + "/assets/planets/Planeta2Roughness.png");

export default PlanetTwo;
